import React, {useEffect, useState} from "react";
import Modal from "react-bootstrap/esm/Modal";
import Button from "react-bootstrap/Button";
import ReactFlagsSelect from "react-flags-select";
import CreditCardsImage from "../../../public/img/credit-cards.svg";

const SelectCountryModal = ({selectedCountry, setInternationalizationModal, setSelectedCountry, showInternationalizationModal, availableCountries}) => {
    const [localStateCountry, setLocalStateCountry] = useState(selectedCountry);
    const countriesIsoCodes = [];
    availableCountries.forEach(country => {
        countriesIsoCodes.push(country.isoCode);
    })
    useEffect(() => {
        setLocalStateCountry(selectedCountry);
    }, [selectedCountry])

    const handleUpdateCountry = () => {
        setSelectedCountry(localStateCountry);
    }

    return (
        <Modal
            show={showInternationalizationModal}
            centered
            onHide={() => setInternationalizationModal(false)}
            className="internationalization-modal"
            container={document.getElementById('react-popup-container')}
            scrollable={false}
            animation={true}
            backdropClassName="overlay-second-modal internationalization-backdrop"
        >
            <Modal.Header className="internationalization-modal__header" closeButton closeLabel='Close'>
                <Modal.Title>
                    <div>UPDATE YOUR SHIPPING</div>
                    <div>DESTINATION & CURRENCY</div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="internationalization-modal__body">
                <div className='shipping-description'>{`You are currently shipping to `}</div>
                <div className='shipping-country'>{`${localStateCountry.name} (${localStateCountry?.currency.isoCode} ${localStateCountry.currency.symbol})`}</div>
                <div className='change-to-label'>CHANGE TO:</div>
                <ReactFlagsSelect
                    searchable
                    countries={countriesIsoCodes}
                    rfsKey="country-select"
                    selected={localStateCountry.isoCode}
                    onSelect={(code) => setLocalStateCountry(availableCountries.filter(item => item.isoCode === code)[0])}
                />
                <div className='shipping-location'>You can change your shipping destination at checkout.</div>
                <div className='footer-payment-icons'>
                    <CreditCardsImage alt="Credit Cards" />
                </div>
                <Button variant="dark"
                        className='update-preferences-button'
                        onClick={() => handleUpdateCountry()}>
                    SAVE SETTINGS
                </Button>
            </Modal.Body>
        </Modal>
    )
};

export default SelectCountryModal;